import type { ReactNode } from 'react';

export const symbol_thumbs_up_double: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M672-678h188q24.75 0 42.38 17.62Q920-642.75 920-618v39q0 6-1.5 12t-3.5 11L808-305q-3.89 7.92-11.28 12.96Q789.33-287 780-287q-16.13 0-24.57-13.5Q747-314 753-329l107-251v-38H638q-14.48 0-23.24-10-8.76-10-6.76-24l18-126q-13 13-25.5 26T575-726q-9 9-21 9t-21-8.84q-9-8.84-9-21t9-21.16l90-91q9-9 21-9t21 9l8 8q10 10 14.5 23.5T690-800l-18 122ZM69.82-120Q57-120 48.5-128.63 40-137.25 40-150v-332q0-12.75 8.63-21.38Q57.25-512 70-512h150v60H100v272h120v60H69.82ZM515-120H160v-357l214-216q9-9 21-9t21 9l8 8q10 10 14.5 23.5T441-634l-17 122h190q24.75 0 42.38 17.62Q674-476.75 674-452v39q0 6.26-1.5 12.13Q671-395 669-390l-98 233q-7 17-22.31 27-15.31 10-33.69 10Zm0-60 99-234v-38H389q-13.71 0-22.86-10-9.14-10-7.14-24l18-125-157 159v272h295Zm-295 0v-306 306Z"
		/>
	</svg>
);
